import { render } from "./detail-staff-bill.vue?vue&type=template&id=d7abca62&ts=true"
import script from "./detail-staff-bill.vue?vue&type=script&lang=ts"
export * from "./detail-staff-bill.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__